import {gsap} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";

export default class HeaderBurger {

	static init() {
		this.header = document.querySelector(".header-main-burger");
		if (this.header) {
			Header.init();
			this.initSubnav();
			GlobalVariables.resizeCallbacks.push(this);
		}
	}

	static initSubnav(){

		this.menuLevelOne = this.header.querySelectorAll('.menu-item--lev1.menu-item-has-children');

		this.menuLevelOne.forEach((item) => {
			let subNav = item.querySelector('.lev2');
			subNav.style.height = "auto";
			subNav.dataset.height = subNav.offsetHeight;
			subNav.style.height = 0;
			item.classList.remove("subnav-open");
			item.querySelector(":scope > a").addEventListener("click", Header.openSubNavBurger );
		});

	}

	static resize(){

		this.initSubnav();
		if (window.innerWidth > 991) {
			document.body.classList.remove("nav-main-open");
			GlobalVariables.smoother.paused( false );
		}

	}
}
